import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchHeader } from "./header.service";
import { HeaderResponse } from "./header.types";
import { handleApiError } from "@/app/utils/handleApiError";
import { RootState } from "../../store";
import { RejectValueType } from "../redux/redux.types";

export const getHeader = createAsyncThunk<
  HeaderResponse,
  void,
  RejectValueType & { state: RootState }
>(
  "header/getHeader",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchHeader();
      return response;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
  {
    condition: (_, { getState }) => {
      const { header } = getState();
      // If data already exists, don't fetch again
      if (header.data) return false;
      // If already loading, don't fetch again
      if (header.status === "loading") return false;
      return true;
    },
  },
);
